import { Overrides } from '@material-ui/core/styles/overrides';
import pallete from '../palette';

const MuiTablePagination: Overrides['MuiTablePagination'] = {
  root: {
    '& .MuiToolbar-root': {
      backgroundColor: pallete.grey['50'],
    },
  },
};

export default MuiTablePagination;
